import { render, staticRenderFns } from "./5-PremiumPage.vue?vue&type=template&id=119bbafe"
import script from "./5-PremiumPage.vue?vue&type=script&lang=js"
export * from "./5-PremiumPage.vue?vue&type=script&lang=js"
import style0 from "./5-PremiumPage.vue?vue&type=style&index=0&id=119bbafe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports